@if (loading) {
  <div class="loading-indicator">
    <p-progressSpinner></p-progressSpinner>
  </div>
}
<div class="readonlytbox">
  <div class="edittablebdr m-0">
    <div class="rtnav ui-g">
      <div class="ui-g-8 msgbox-6">
        @for (message of msgsEngDetails; track message) {
          <p-message [life]="3000" [text]="message.detail"></p-message>
        }
      </div>
      @if (!btnNavEngDetails) {
        <div class="ui-g-3"></div>
      }
      @if (btnNavEngDetails) {
        <div class="ui-g-3">
          <button
            type="button"
            pButton
            (click)="editPartnerDetailsCancel()"
            class="ui-button-secondary flat fl-rt">
            Cancel
          </button>
          <button
            type="submit"
            pButton
            (click)="onSubmitPartnerDetails()"
            class="flat btnmr fl-rt">
            Save
          </button>
        </div>
      }
      <div class="ui-g-1 edit-history-icon">
        <span
          class="fa fa-pencil ico cpointer fl-rt"
          pTooltip="Edit"
          (click)="editPartnerDetails()"
          (keydown.enter)="editPartnerDetails()"
          tabindex="0"
          tooltipPosition="bottom"></span>
        @if (release === 'Prod' && isMRPPProgram) {
          <a
            target="_blank"
            href="https://msit.powerbi.com/groups/bb67cbd8-99ea-4206-8501-7536c68201a7/reports/94a5287e-f98e-4494-8a7d-7c8bc1fbb0f2/ReportSection93188d28fe904944dd33?filter=Master_Engagement/EngagementKey eq '{{
              eventRegistrationId
            }}'"
            tooltipPosition="bottom"
            pTooltip="History"
            class="fa fa-history icohistory fl-rt"
            aria-hidden="true">
          </a>
        }
        @if (release !== 'Prod' && isMRPPProgram) {
          <a
            target="_blank"
            href="https://msit.powerbi.com/groups/b7cf08d2-8c22-4aa9-9a79-f4a8cd991f77/reports/1c164c70-828c-401d-b87a-2c075eab2888/ReportSection93188d28fe904944dd33?filter=Master_Engagement/EngagementKey eq '{{
              eventRegistrationId
            }}'"
            tooltipPosition="bottom"
            pTooltip="History"
            class="fa fa-history icohistory fl-rt"
            aria-hidden="true">
          </a>
        }
      </div>
    </div>
    <form
      [formGroup]="formPartnerDetails"
      #localForm="ngForm"
      class="form-partner-details">
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <div class="hdorg">System Generated</div>
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <div class="hdorg">PMO Confirmed</div>
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Partner ID</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            formControlName="partnerMpnId"
            pInputText
            readonly />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            formControlName="pmoconfirmedPartnerMpnid"
            pInputText
            [readonly]="isReadonlyEng" />
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Partner Name</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            formControlName="partnerName"
            pInputText
            readonly />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            formControlName="pmoconfirmedPartnerName"
            pInputText
            [readonly]="isReadonlyEng" />
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          Partner Input - Requestor Contact
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            formControlName="partnerInputRequestorContact"
            pInputText
            [readonly]="isReadonlyEng" />
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Partner Input - Partner Info</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            formControlName="partnerInputRequestorEmail"
            pInputText
            [readonly]="isReadonlyEng" />
        </div>
      </div>
      @if (categoryName === 'MRPP') {
        <div class="ui-g">
          <div class="ui-g-12 ui-md-4 ui-lg-4">Customer Location</div>
          <div class="ui-g-12 ui-md-4 ui-lg-4">
            <input
              type="text"
              formControlName="customerCountry"
              pInputText
              readonly />
          </div>
          <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
        </div>
      }
      <div class="ui-g">
        <div class="ui-g-12 ui-md-12 ui-lg-12">
          <div class="hdbl">Internal Reference</div>
        </div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Partner Name</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            formControlName="partnerName"
            pInputText
            readonly />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Partner One ID</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            formControlName="partnerOneId"
            pInputText
            readonly />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Partner Location</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            formControlName="partnerLocation"
            pInputText
            readonly />
        </div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
      </div>
      @if (categoryName === 'MRPP') {
        <div class="ui-g">
          <div class="ui-g-12 ui-md-4 ui-lg-4">Partner Earned Location</div>
          <div class="ui-g-12 ui-md-4 ui-lg-4">
            <input
              type="text"
              formControlName="partnerEarnedLocation"
              pInputText
              readonly />
          </div>
          <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
        </div>
        <div class="ui-g">
          <div class="ui-g-12 ui-md-4 ui-lg-4">Partner Area Location (A15)</div>
          <div class="ui-g-12 ui-md-4 ui-lg-4">
            <input
              type="text"
              formControlName="partnerAreaLocationA14"
              pInputText
              readonly />
          </div>
          <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
        </div>
      }
      <div class="ui-g">
        <div class="ui-g-12 ui-md-4 ui-lg-4">Additional Contact Info</div>
        <div class="ui-g-12 ui-md-4 ui-lg-4"></div>
        <div class="ui-g-12 ui-md-4 ui-lg-4">
          <input
            type="text"
            formControlName="additionalContactEmails"
            pInputText
            [readonly]="isReadonlyEng" />
        </div>
      </div>
    </form>
  </div>
</div>
